import React, { useEffect, useState } from 'react';
import { ScreenRouter } from './nav';
import { PhoneFrame } from './components/PhoneFrame';
import { ScreenView } from './components/ScreenView';
import { VE_BANK_ASSETS } from './lib/brand';
import { Landing } from './pages/Landing';
const screens = [{
  title: '1. Splash',
  path: '/splash'
}, {
  title: '2. Login',
  path: '/login'
}, {
  title: '3. Home',
  path: '/home'
}, {
  title: '4. Vee AI Chat',
  path: '/chat'
}, {
  title: '5. New Transfer',
  path: '/transfer'
}, {
  title: '6. Draft Transfer',
  path: '/draft'
}, {
  title: '7. Review & Confirm',
  path: '/review'
}, {
  title: '8. Success',
  path: '/success'
}, {
  title: '9. History',
  path: '/history'
}, {
  title: '10. Bills & Airtime',
  path: '/bills'
}, {
  title: '11. Profile & Security',
  path: '/profile'
}, {
  title: '12. Account Details',
  path: '/account'
}];

/** Screens that paint their own navy canvas. */
const darkRoutes = ['/splash', '/chat', '/review'];
function Gallery({
  onFullscreen
}: {
  onFullscreen: () => void;
}) {
  return <main className="min-h-screen bg-brand-cloud px-4 py-8 font-sans sm:p-10" data-id="element-0" data-mp="3iiwdijzxza14">
      <div className="mx-auto max-w-[1800px]" data-id="element-1" data-mp="3ml14faz09sk2">
        <header className="mb-10 text-center" data-id="element-2" data-mp="3mjq1fdddwou0">
          <div className="mx-auto inline-flex rounded-2xl bg-white px-5 py-3 shadow-soft" data-id="element-3" data-mp="3rcj2nr9n9f1c">
            <img src={VE_BANK_ASSETS.wordmark} alt="VE Bank" className="h-8 w-auto" data-id="element-4" data-mp="5otf64sd496" />
          </div>
          <h1 className="mt-5 text-3xl font-extrabold text-brand-navy sm:text-4xl" data-id="element-5" data-mp="2zld2xbxu5jcl">VE Bank product prototype</h1>
          <p className="mt-2 text-base text-brand-slate" data-id="element-6" data-mp="33m5eibu6k0c1">Explore each screen and the complete customer-controlled banking flow.</p>
          <button onClick={onFullscreen} className="mt-6 inline-flex min-h-[44px] items-center rounded-xl bg-brand-cobalt px-5 text-sm font-extrabold text-white transition-transform active:scale-95" data-id="element-7" data-mp="38k6tolohjfi8">
            Play prototype fullscreen
          </button>
        </header>
        <div className="flex flex-col items-center gap-10 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-12" data-id="element-8" data-mp="stuclog6yl6w">
          {screens.map(screen => <PhoneFrame key={screen.path} title={screen.title} dark={darkRoutes.includes(screen.path)} data-id="element-9" data-mp="38ktuby5znfz">
              <ScreenRouter initialPath={screen.path} data-id="element-10" data-mp="3uf5hdlp0gd89"><ScreenView data-id="element-11" data-mp="d4xqnip0ahey" /></ScreenRouter>
            </PhoneFrame>)}
        </div>
      </div>
    </main>;
}
function Shell() {
  const [tab, setTab] = useState<'landing' | 'prototype' | 'fullscreen'>('landing');
  useEffect(() => {
    const onFullscreenChange = () => {
      if (!document.fullscreenElement && tab === 'fullscreen') {
        setTab('prototype');
      }
    };
    document.addEventListener('fullscreenchange', onFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, [tab]);
  const enterFullscreen = () => {
    setTab('fullscreen');
    document.documentElement.requestFullscreen().catch(() => {});
  };
  const exitFullscreen = () => {
    setTab('prototype');
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    }
  };
  if (tab === 'fullscreen') {
    return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm sm:p-8" data-id="element-12" data-mp="1d4ztku6qf4s1">
        <ScreenRouter initialPath="/splash" data-id="element-13" data-mp="ygd5a2z4n2oo">
          {/* Mobile: True fullscreen */}
          <div className="phone-scroll relative flex h-full w-full flex-col overflow-y-auto bg-brand-cloud sm:hidden" data-id="element-14" data-mp="13e52ncijjh09">
            <ScreenView data-id="element-15" data-mp="1r5ai3qkkk7a1" />
          </div>
          
          {/* Desktop: Mobile viewport modal */}
          <div className="hidden h-full max-h-[844px] w-full max-w-[390px] sm:flex" data-id="element-16" data-mp="1w2104jfxpcy3">
            <div className="relative flex h-full w-full flex-col overflow-hidden rounded-[42px] border-[7px] border-[#04111d] bg-brand-cloud shadow-2xl" data-id="element-17" data-mp="1i4chli9cahw7">
              <div className="pointer-events-none absolute inset-x-0 top-0 z-50 flex h-7 justify-center" data-id="element-18" data-mp="1m70qfpy1zot6">
                <div className="h-[29px] w-[122px] rounded-b-[18px] bg-[#04111d]" data-id="element-19" data-mp="aq0xcs3vt5y3" />
              </div>
              <div className="phone-scroll relative flex h-full w-full flex-col overflow-y-auto" data-id="element-20" data-mp="qx5h40meusbj">
                <ScreenView data-id="element-21" data-mp="m6fciplt6thw" />
              </div>
            </div>
          </div>
        </ScreenRouter>

        <button onClick={exitFullscreen} className="fixed right-4 top-4 z-[110] flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition-colors hover:bg-white/20" aria-label="Exit fullscreen" data-id="element-22" data-mp="h72qg72rhqgd">
          ✕
        </button>
      </div>;
  }
  return <div className="min-h-screen bg-brand-cloud font-sans [overflow-x:clip]" data-id="element-23" data-mp="14y83kehbi4mz">
      <div className="sticky top-0 z-[60] border-b border-slate-200 bg-white/95" data-id="element-24" data-mp="zx29ac80e9bc">
        <div className="mx-auto flex max-w-7xl justify-center px-6 py-2" data-id="element-25" data-mp="vwibd6fm31o5">
          <div role="tablist" aria-label="View" className="inline-flex rounded-2xl border border-slate-200 bg-brand-cloud p-1" data-id="element-26" data-mp="vyl0lo8xwqrt">
            <button role="tab" aria-selected={tab === 'landing'} onClick={() => setTab('landing')} className={`min-h-[44px] rounded-xl px-5 text-sm font-bold ${tab === 'landing' ? 'bg-brand-navy text-white shadow-sm' : 'text-brand-slate'}`} data-id="element-27" data-mp="3glxz1sjjaa9k">Landing page</button>
            <button role="tab" aria-selected={tab === 'prototype'} onClick={() => setTab('prototype')} className={`min-h-[44px] rounded-xl px-5 text-sm font-bold ${tab === 'prototype' ? 'bg-brand-navy text-white shadow-sm' : 'text-brand-slate'}`} data-id="element-28" data-mp="203xozlh4nqqy">Prototype</button>
          </div>
        </div>
      </div>
      {tab === 'landing' ? <Landing onLaunch={enterFullscreen} data-id="element-29" data-mp="2jtr8lc9ouzk3" /> : <Gallery onFullscreen={enterFullscreen} data-id="element-30" data-mp="2jsohp4cd8x46" />}
    </div>;
}
function getInitialPath() {
  if (typeof window === 'undefined') return '/';
  return `${window.location.pathname || '/'}${window.location.search || ''}`;
}
export function App() {
  const initialPath = getInitialPath();
  if (initialPath === '/' || initialPath === '') return <Shell data-id="element-31" data-mp="tjo82zvn3jc0" />;
  return <ScreenRouter initialPath={initialPath} data-id="element-32" data-mp="ygojlqb9deai"><ScreenView data-id="element-33" data-mp="yhpsbo4sxop2" /></ScreenRouter>;
}